import { UIHeading5 } from '@cian/ui-kit';
import { NumberInputWithButtons } from '../../../../../packages/NumberInputWithButtons';
import { FC } from 'react';
import styles from './DropdownBeds.css';

interface IDropdownBedsProps {
  value: number;
  min: number;
  max: number;

  onChange(value: number): void;
}

export const DropdownBeds: FC<IDropdownBedsProps> = ({ value, min, max, onChange }) => {
  return (
    <div className={styles['dropdown']} data-testid="DropdownBeds">
      <div className={styles['heading']}>
        <UIHeading5>Количество гостей</UIHeading5>
      </div>

      <NumberInputWithButtons size="XS" value={value} onChange={onChange} min={min} max={max} />
    </div>
  );
};
